import styled, { css } from 'styled-components'

// O "&&" garante prioridade sobre a regra genérica `input` do InputDiv.
export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  && {
    flex: none;
    width: 28px;
    height: 28px;
    padding: 0;
    margin: 0;
    cursor: pointer;
    accent-color: ${({ theme }) => theme.colors.primary};
  }
`

export const ConfigDetails = styled.details`
  margin: 8px 0 16px;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.surfaceElevated};

  summary {
    cursor: pointer;
    font-weight: bold;
  }

  summary small {
    display: block;
    margin-top: 4px;
    font-weight: normal;
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  &[open] summary {
    margin-bottom: 16px;
  }
`

export const SectionTitle = styled.h3`
  margin-top: 32px;
  margin-bottom: 12px;
`

export const ResultSection = styled.section`
  margin-top: 28px;

  h3 {
    margin: 0 0 12px;
  }

  p {
    margin: 4px 0;
  }
`

export const Hint = styled.p`
  margin: 8px 0 0;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const BoardPath = styled.p`
  margin: -4px 0 16px;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-top: 20px;
`

export const SummaryItem = styled.div`
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.surfaceElevated};

  span {
    display: block;
    font-size: 0.85rem;
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  strong {
    display: block;
    margin-top: 4px;
    font-size: 1.25rem;
  }

  small {
    display: block;
    margin-top: 2px;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`

export const BoardRow = styled.tr`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.tableRowAlt};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.tableRowHover};
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      background-color: ${theme.colors.tableRowHover} !important;
      font-weight: bold;

      td:first-child {
        border-left: 4px solid ${theme.colors.primary};
      }
    `}
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    transition:
      transform 0.15s ease,
      color 0.15s ease;

    svg {
      height: 25px;
      width: 25px;
    }

    &:hover {
      transform: translateY(-1px) scale(1.05);
    }

    &:active {
      transform: translateY(0) scale(0.97);
    }
  }
`

export const Th = styled.th`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  padding: 10px;
  text-align: left;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Td = styled.td`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.border};
`

export const Tr = styled.tr`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.tableRowAlt};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.tableRowHover};
  }
`

export const TableContainer = styled.div`
  overflow-x: auto;
  max-width: 100%;
`

export const AddButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  margin-top: 0;
  transition:
    transform 0.15s ease,
    color 0.15s ease;

  svg {
    height: 30px;
    width: 30px;
  }

  &:hover {
    transform: translateY(-1px) scale(1.05);
  }

  &:active {
    transform: translateY(0) scale(0.97);
  }
`

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: ${({ theme }) => theme.colors.overlay};
  backdrop-filter: blur(2px);
`

export const ModalBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ $size }) => ($size === 'lg' ? '860px' : '620px')};
  max-height: calc(100vh - 32px);
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textPrimary};
  box-shadow: ${({ theme }) => theme.colors.cardShadow};

  &:focus {
    outline: none;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  h2 {
    margin: 0;
    font-size: 1.2rem;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 8px;
    background: none;
    color: inherit;
    cursor: pointer;

    &:hover {
      background: ${({ theme }) => theme.colors.tableRowHover};
    }
  }
`

// Só o corpo rola: no celular o cabeçalho e os botões continuam visíveis.
export const ModalBody = styled.div`
  flex: 1;
  min-height: 0;
  padding: 16px 20px;
  overflow-y: auto;
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 14px 20px;
  border-top: 1px solid ${({ theme }) => theme.colors.border};

  @media (max-width: 720px) {
    flex-direction: column-reverse;
  }
`

export const ActionButton = styled.button`
  min-height: 42px;
  padding: 0 20px;
  border: 1px solid ${({ theme, $variant }) => ($variant === 'secondary' ? theme.colors.inputBorder : 'transparent')};
  border-radius: 8px;
  background: ${({ theme, $variant }) =>
    $variant === 'secondary' ? 'transparent' : $variant === 'danger' ? theme.colors.danger : theme.colors.primary};
  color: ${({ theme, $variant }) => ($variant === 'secondary' ? theme.colors.textPrimary : theme.colors.onPrimary)};
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover:not(:disabled) {
    opacity: 0.88;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const TabsBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 12px 0;
`

export const TabButton = styled.button`
  height: auto !important;
  padding: 8px 16px;
  border: 1px solid ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.inputBorder)};
  border-radius: 999px;
  background: ${({ theme, $active }) => ($active ? theme.colors.primary : 'transparent')};
  color: ${({ theme, $active }) => ($active ? theme.colors.onPrimary : theme.colors.textPrimary)};
  font-size: 15px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  cursor: pointer;
  margin-left: ${({ $depth }) => ($depth ? `${$depth * 8}px` : 0)};

  small {
    margin-left: 6px;
    opacity: 0.8;
  }
`

export const SummaryBar = styled.div`
  position: sticky;
  top: 70px;
  z-index: 100;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 24px;
  margin: 12px 0;
  padding: 10px 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-left: 4px solid ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.surfaceElevated};
  box-shadow: ${({ theme }) => theme.colors.cardShadow};

  @media (max-width: 720px) {
    top: 60px;
    gap: 4px 16px;
  }

  strong {
    margin-right: 4px;
  }

  span {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  b {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`

export const ToolbarRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 24px;

  h3 {
    margin: 0;
  }
`

export const StaleBanner = styled.div`
  margin-bottom: 16px;
  padding: 12px 16px;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(245, 158, 11, 0.15)' : '#fffbeb')};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 600;
`

export const CircuitRow = styled(Tr)`
  cursor: grab;

  ${({ $dragOver, theme }) =>
    $dragOver &&
    css`
      box-shadow: inset 0 3px 0 ${theme.colors.primary};
    `}

  ${({ $invalid, theme }) =>
    $invalid &&
    css`
      background-color: ${theme.mode === 'dark' ? 'rgba(248, 113, 113, 0.18)' : 'rgba(239, 68, 68, 0.12)'} !important;

      td:first-child {
        border-left: 4px solid ${theme.colors.danger};
      }
    `}
`

export const CheckList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 320px;
  margin-top: 8px;
  overflow-y: auto;

  label {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 8px;
    cursor: pointer;
  }

  label small {
    margin-left: auto;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`

export const FieldRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;

  > label {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 6px;
    min-width: 180px;
    font-size: 15px;
  }

  input[type='text'],
  input[type='number'] {
    width: 100%;
    box-sizing: border-box;
    padding: 12px;
    border: 1px solid ${({ theme }) => theme.colors.inputBorder};
    border-radius: 6px;
    background: ${({ theme }) => theme.colors.inputBackground};
    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 16px;

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }

  select {
    margin-left: 0;
  }
`

export const InlineCheck = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 180px;
  cursor: pointer;
`

export const Tag = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: ${({ theme, $warn }) => ($warn ? 'rgba(245, 158, 11, 0.2)' : theme.colors.surfaceMuted)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 0.8rem;
`
